import { Preview } from "../../../types/IAction";

export interface PrecalculoStore {
  postingSimulacionCierre: boolean;
  historialSimulacionCierre: Preview<any>;
  loadingHistorialSimulacion: boolean;
}

export const precalculoStore = (state): PrecalculoStore => {
  return {
    postingSimulacionCierre: state.reports.postingSimulacionCierre,
    historialSimulacionCierre: state.reports.historialSimulacionCierre,
    loadingHistorialSimulacion: state.reports.loadingHistorialSimulacion
  };
};
